import * as React from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import Typography from '@mui/material/Typography';
import {useTranslation} from "react-i18next";
import {Card, CardContent, CardHeader, Divider, Grid, Select, TextField, Toolbar} from "@mui/material";
import Box from "@mui/material/Box";
import TableContainer from "@mui/material/TableContainer";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import PlanningSummary from "./PlanningSummary";
import {Formik} from "formik";
import * as Yup from "yup";

const emails = ['username@gmail.com', 'user02@gmail.com'];
function ManageCarryScore(props) {
    const {t} = useTranslation()
    return (
        <Grid lg={12} md={12} m={0} p={2}>
            <Toolbar>
                <Typography>
                    {t('label.xxxAdd')}
                </Typography>
                <Box sx={{flex: 1}}/>
                <Button>X</Button>
            </Toolbar>
            <Divider/>
            <Grid container>
                <Grid item lg={8}>
                    <Typography>
                        header
                    </Typography>
                    <Typography>
                        header desc
                    </Typography>
                </Grid>
                <Grid item lg={4}>
                    <Card><CardContent> test </CardContent></Card>
                </Grid>
            </Grid>
            <Grid container>
                <Grid item lg={6}>
                    <Typography> test </Typography>
                    <Typography> test desc</Typography>

                </Grid>
                <Grid item lg={6}>
                    <Typography> test </Typography>
                    <Typography> test desc</Typography>

                </Grid>
                <Grid item lg={6}>
                    <Typography> test </Typography>
                    <Typography> test desc</Typography>

                </Grid>
                <Grid item lg={6}>
                    <Typography> test </Typography>
                    <Typography> test desc</Typography>
                </Grid>
                <Grid item lg={6}>
                    <Typography> test </Typography>
                    <Typography> test desc</Typography>

                </Grid>
                <Grid item lg={6}>
                    <Typography> test </Typography>
                    <Typography> test desc</Typography>

                </Grid>
                <Grid item lg={6}>
                    <Typography> test </Typography>
                    <Typography> test desc</Typography>

                </Grid>
                <Grid item lg={6}>
                    <Typography> test </Typography>
                    <Typography> test desc</Typography>
                </Grid>
            </Grid>
            <Button> {t('label.back')}</Button>
        </Grid>
    );
}
function SimpleDialog(props) {
    const {onClose, selectedValue, open} = props;
    const handleClose = () => {
        onClose(selectedValue);
    };
    const handleListItemClick = (value) => {
        onClose(value);
    };
    return (
         <Dialog onBackdropClick={() => {return false}} onClose={handleClose} open={open} maxWidth='lg'>
            <ManageCarryScore/>
        </Dialog>
    );
}
SimpleDialog.propTypes = {
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    selectedValue: PropTypes.string.isRequired,
};
export default function DialogItemWorkDetail() {
    const {t} = useTranslation();
    const [open, setOpen] = React.useState(false);
    const [selectedValue, setSelectedValue] = React.useState(emails[1]);
    const handleClickOpen = () => {
        setOpen(true);
    };
    const handleClose = (value) => {
        setOpen(false);
        setSelectedValue(value);
    };
    return (
        <div>
            <Typography variant="subtitle1" component="div">
                Selected: {selectedValue}
            </Typography>
            <br/>
            <Button variant="outlined" onClick={handleClickOpen}>
                DialogItemWorkDetail
            </Button>
            <SimpleDialog
                selectedValue={selectedValue}
                open={open}
                onClose={handleClose}
            />
        </div>
    );
}
